// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type TaetigkeitsberichteInternPage } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export type SucheInterneTaetigkeitsberichteQuery = {
  freigegeben?: boolean;
  search?: string;
  filtered?: string;
  page?: number;
  limit?: number;
  sort?: string;
  startDate?: string;
  endDate?: string;
};

export function useSucheInterneTaetigkeitsberichte(): (
  query: SucheInterneTaetigkeitsberichteQuery
) => Promise<TaetigkeitsberichteInternPage> {
  const getAPI = useGetApi();
  return useCallback(
    async (query = {}) =>
      (await getAPI()).taetigkeitsberichte.sucheInterneTaetigkeitsberichte({
        ...query,
      }),
    [getAPI]
  );
}
